import React from 'react';
import type { SelectOption } from '../../types';
import { Box } from '@beeline.com/bp-design-system';
import { MultiSelect } from './Multiselect';
import { selectStyleProps, tableSelectSx } from './styles';

interface Props {
  onChange: (value: SelectOption[] | null) => void;
  value?: SelectOption[];
  options: readonly SelectOption[];
  sort?: boolean;
}

export const TableMultiSelect = ({ onChange, value, options, sort }: Props) => {
  const handleChange = (nextValue: SelectOption[]) => {
    if (hash(value) !== hash(nextValue)) {
      onChange(nextValue);
    }
  };

  return (
    <Box sx={tableSelectSx}>
      <MultiSelect
        value={value}
        onChange={handleChange}
        placeholder=" "
        options={options}
        open
        style={selectStyleProps}
        sort={sort}
      />
    </Box>
  );
};

function hash(values: SelectOption[] | undefined) {
  return (
    values
      ?.map((v) => v.value)
      .sort()
      .join('') ?? ''
  );
}
